import React from "react";
import PropTypes from "prop-types";
import DetailsTable from "../../../../Table/DetailsTable";
import {
    IconButton,
    Stack,
    CommandBarButton
} from "@fluentui/react";
import FeatureSummary from "../../../../Util/FeatureSummary";

const NotificationsTable = ({
    notifications,
    setSelectedNotificationId,
    setSelectedNotificationTitle,
    loading,
    createOnClick,
    deleteOnClick,
    editOnClick,
}) => {
    const columns = () => [
        {
            key: 'column1',
            name: 'Id',
            fieldName: 'notificationId',
            minWidth: 30,
            maxWidth: 30,
            isResizable: true,
        },
        {
            key: 'column2',
            name: 'Notification Title',
            fieldName: 'title',
            minWidth: 550,
            isResizable: true,
            onRender: (item) => (
                <Stack horizontal horizontalAlign="space-between">
                    {item?.title ?? ""}
                    <ContextualMenu
                        editOnClick={editOnClick}
                        deleteOnClick={deleteOnClick}
                        id={item.notificationId}
                        title={item?.title ?? ""}
                    />
                </Stack>
            ),
        },
        {
            key: 'column3',
            name: 'Active From',
            fieldName: 'activeFrom',
            minWidth: 150,
            maxWidth: 150,
            isResizable: true,
        },
        {
            key: 'column4',
            name: 'Active To',
            fieldName: 'activeTo',
            minWidth: 150,
            maxWidth: 150,
            isResizable: true,
        },
        {
            key: 'column5',
            name: 'Status',
            fieldName: 'status',
            minWidth: 70,
            maxWidth: 70,
            isResizable: true,
        },
    ];

    const items = notifications ?? [];

    const selectionHook = (items) => {
        const selectedItem = items && items[0];
        setSelectedNotificationId(selectedItem && selectedItem.notificationId);
        setSelectedNotificationTitle?.(selectedItem?.title || "");
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns()}
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={"title"}
                style={{
                    position: "relative",
                    height: "80vh",
                    width: "80vw",
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: "Add" }}
                        text="Add Notification"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Site Notifications"
                summary="This table displays all site notifications, including their title, active dates, and status. You can add, edit, or delete notifications. This feature allows admins to create and manage messages that are displayed to users across the platform."
                imageUrlPath='notification2'
            />
        </>
    );
}

const moreIcon = { iconName: "More" };

const ContextualMenu = ({
    editOnClick,
    deleteOnClick,
    title,
    id,
    ...rest
}) => {
    const menuProps = {
        items: [
            {
                key: "Edit",
                iconProps: { iconName: "Edit" },
                text: "Edit",
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, title),
            }
        ],
    };

    return (
        <IconButton
            iconProps={moreIcon}
            menuProps={menuProps}
            onRenderMenuIcon={() => { }}
            {...rest}
        />
    );
};

NotificationsTable.propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.shape({
        notificationId: PropTypes.number,
        title: PropTypes.string,
    })),
    setSelectedNotificationId: PropTypes.func.isRequired,
    setSelectedNotificationTitle: PropTypes.func,
    loading: PropTypes.bool,
    createOnClick: PropTypes.func.isRequired,
    deleteOnClick: PropTypes.func.isRequired,
    editOnClick: PropTypes.func.isRequired,
};

ContextualMenu.propTypes = {
    editOnClick: PropTypes.func.isRequired,
    deleteOnClick: PropTypes.func.isRequired,
    title: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default NotificationsTable;
